module.exports = __webpack_public_path__ + "static/img/m_role.1277c8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/kr/m_role.png
// module id = vxjn
// module chunks = 7